import { IonModal } from '@ionic/angular';

export class GetGroupByIdAction {
  static readonly type = '[GroupContent] GetGroupByIdAction';

  constructor(public id: string) {}
}

export class RequestToJoinGroupAction {
  static readonly type = '[GroupContent] RequestToJoinGroupAction';

  constructor(public message: string, public modalToClose: IonModal) {}
}

export class LeaveGroupAction {
  static readonly type = '[GroupContent] LeaveGroupAction';

  constructor(public nextOwnerId?: string) {}
}

export class TransferGroupOwnershipAction {
  static readonly type = '[GroupContent] TransferGroupOwnershipAction';

  constructor(public groupId: string, public nextOwnerId: string) {}
}

// SMA-185 Q6. Archiving freezes the group (read-only); reactivating undoes it.
// Both reload the group afterwards so `isArchived` comes from the server, never
// from an optimistic guess the back end might disagree with.
export class ArchiveGroupAction {
  static readonly type = '[GroupContent] ArchiveGroupAction';

  constructor(public groupId: string) {}
}

export class UnarchiveGroupAction {
  static readonly type = '[GroupContent] UnarchiveGroupAction';

  constructor(public groupId: string) {}
}

export class RemovePendingUserFromListAction {
  static readonly type = '[GroupContent] RemovePendingFromListAction';

  constructor(public userId: string) {}
}

export class KickUserAction {
  static readonly type = '[GroupContent] KickUserAction';

  constructor(public userId: string, public groupId: string) {}
}

export class AddAdminAction {
  static readonly type = '[GroupContent] AddAdminAction';

  constructor(public userId: string, public groupId: string) {}
}

export class RemoveAdminAction {
  static readonly type = '[GroupContent] RemoveAdminAction';

  constructor(public userId: string, public groupId: string) {}
}

// SMA-185 Q7. Name a member « Entraîneur » of the group, or take the role
// away. Like the admin and archive actions, both reload the group afterwards so
// trainers[] comes from the server, never from an optimistic guess.
export class AssignTrainerAction {
  static readonly type = '[GroupContent] AssignTrainerAction';

  constructor(public userId: string, public groupId: string) {}
}

export class RemoveTrainerAction {
  static readonly type = '[GroupContent] RemoveTrainerAction';

  constructor(public userId: string, public groupId: string) {}
}
